import React, { useEffect, useState } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Typography,
    CircularProgress,
    TablePagination,
    Box,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import APIURL, { IMAGE_BASE_URL } from "../api/apiClient"; // your base API URL
import { message } from "antd";
import Loader from "../components/Loader";


const OffersTable = () => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5); // default rows per page
    const [offers, setOffers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchOffers = async () => {
            try {
                const { data } = await APIURL.get("/fetchofferitems.php");
                //   console.log("Raw response data:", data);

                if (data) {
                    if (Array.isArray(data) && data.length > 0) {
                        const formatted = data.map((item) => ({
                            ...item,
                            image: item.image ? item.image[0] : "", // first image if array
                        }));
                        setOffers(formatted);
                    } else {
                        // Empty data array
                        setOffers([]);
                        console.warn("No offers found.");
                    }
                } else {
                    // Backend returned success = false
                    setOffers([]);
                    console.error(data.message || "Failed to fetch offers.");
                }
            } catch (err) {
                console.error("Error fetching offers:", err);
                setOffers([]);
            } finally {
                setLoading(false);
            }
        };

        fetchOffers();
    }, []);



    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Would you like to delete?")) return;

        try {
            let response = await APIURL.delete(`/deleteofferitem.php?id=${id}`);

            // If response is a string (not JSON), try to parse it
            if (typeof response === "string") {
                try {
                    response = JSON.parse(response.trim());
                } catch {
                    // fallback if not JSON
                    response = { success: false, message: response };
                }
            }
            if (response.success) {
                // Update local state without refetching
                setOffers(prev => prev.filter(item => item.id !== id));
                message.success(response.message || "Item deleted successfully.");
            } else {
                message.error(response.message || "Failed to delete item.");
            }
        } catch (error) {
            console.error("Delete Error:", error);
            message.error("Something went wrong while deleting the item.");
        }
    };


    // if (loading) {
    //     return (
    //         <div style={{ display: "flex", justifyContent: "center", padding: 50 }}>
    //             <CircularProgress />
    //         </div>
    //     );
    // }

    return (
        <Paper sx={{ mt: 3, p: 2 }}>
            <Typography variant="h5" gutterBottom sx={{ textDecoration: 'underline' }}>
                Offer Items
            </Typography>
            <TableContainer>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>S. No</TableCell>
                            <TableCell>Image</TableCell>
                            <TableCell>Title</TableCell>
                            <TableCell>Brand</TableCell>
                            <TableCell>MRP</TableCell>
                            <TableCell>Offer Price</TableCell>
                            <TableCell>Selling Price</TableCell>
                            <TableCell>Stock</TableCell>
                            <TableCell align="center">Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {loading ? (
                            // Show loader when data is being fetched
                            <TableRow>
                                <TableCell>
                                    <Box>
                                        <Loader type="table" loading={true} />
                                    </Box>
                                </TableCell>
                            </TableRow>
                        ) : offers.length === 0 ? (
                            // Show this only after loading finishes and no records found
                            <TableRow>
                                <TableCell colSpan={4} align="center">
                                    <Typography variant="body2" color="text.secondary">
                                        No offer items to display
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        ) : (

                            offers
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row, index) => (
                                    <TableRow key={row.id}>
                                        <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                                        <TableCell>
                                            <div
                                                style={{
                                                    width: 80,
                                                    height: 80,
                                                    overflow: "hidden",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <img
                                                    src={
                                                        row.image
                                                            ? `${IMAGE_BASE_URL}${row.image}`
                                                            : `${IMAGE_BASE_URL}uploads/images/imageplaceholder.png`
                                                    }
                                                    alt={row.title}
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = `${IMAGE_BASE_URL}uploads/images/imageplaceholder.png`;
                                                    }}
                                                    style={{
                                                        maxWidth: "100%",
                                                        maxHeight: "100%",
                                                        objectFit: "cover",
                                                        borderRadius: 8,
                                                    }}
                                                />
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body2">{row.title}</Typography>
                                        </TableCell>
                                        <TableCell>{row.brand}</TableCell>
                                        <TableCell>{row.mrp}</TableCell>
                                        <TableCell>{row.actualPrice}</TableCell>
                                        <TableCell>{row.selling_price}</TableCell>
                                        <TableCell>{row.stock}</TableCell>
                                        <TableCell align="center">
                                            <IconButton
                                                color="error"
                                                onClick={() => handleDelete(row.id)}
                                                size="small"
                                            >
                                                <DeleteIcon fontSize="small" />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))
                            )}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                component="div"
                count={offers.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 25]}
                size="small"
            />
        </Paper>
    );
};

export default OffersTable;
